import { VueConstructor } from 'vue';
import { VideoOverlay, VideoOverlayType } from '@/scripts/store/modules/video/state/VideoOverlay';
import GenericErrorOverlay from '../presenters/views/GenericErrorOverlay.ts.vue';
import { extendCommonPresentationOverlay } from './commonPresentationOverlayCreator';

const getPresenterComponent = async(path: string, fallbackComponent?: VueConstructor): Promise<VueConstructor> => {
  try {
    const { default: presenterComponent } = await import(
      /* webpackPreload: true */
      /* webpackChunkName: "video-player-overlays" */
      // eslint-disable-next-line comma-dangle
      `../presenters/views/${path}.ts.vue`
    );
    return presenterComponent;
  } catch (error) {
    if (fallbackComponent) {
      return fallbackComponent;
    }
    throw error;
  }
};

export const importPresenterWithOverlay = async(overlay: VideoOverlay): Promise<VueConstructor> => {
  if (overlay.component) {
    return overlay.component();
  }

  if (overlay.type === VideoOverlayType.Error) {
    return getPresenterComponent(overlay.name, GenericErrorOverlay);
  }

  // If a payload is provided, should try to render payload with generic template.
  if (overlay.presentation) {
    return extendCommonPresentationOverlay(
      await getPresenterComponent('CommonPresentationOverlay'),
      overlay.presentation,
    );
  }

  // If payload is not provided, then throw VideoLoadingError
  return getPresenterComponent(overlay.name);
};
